import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { primaryApi } from '../../utilities/apiEndpointUtility';

import {
	createSubscription,
	createSubscriptionCompleted,
	createSubscriptionFailed
} from './paymentsSlice';

export const createSubscriptionEpic = (action$) =>
	action$.pipe(
		ofType(createSubscription.type),
		mergeMap(async (action) => {
			try {
				const subscription = await axios.post(
					`${primaryApi()}/api/v1/payments/subscription`,
					action.payload
				);

				if (subscription.status === 200) {
					return subscription.data;
				}

				throw new Error('Create Subscription request failed', subscription);
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [createSubscriptionCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(
					createSubscriptionFailed(error.message)
					// failureMessage(error.message)
				),
				source
			);
		})
	);

export default [createSubscriptionEpic];
